import React, { useEffect, useState } from "react";
import { Button, Grid, Typography, Paper, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchContracts,
  fetchPolicyHolderByInsuree,
  fetchPolicyHolderByInsureeByFilter,
} from "../../action";
import { styled } from "@mui/system";
import { decodeId, formatDateFromISO } from "../../utils/helper";
import DatePickers from "../../pickers/DatePicker";
import { Field, Form } from "react-final-form";
import TextInput from "../../reusableComponents/components/generics/TextInput";
import CalendarPicker from "../../pickers/CalenderPicker";

const StyledPaper = styled(Paper)(({ theme }) => ({
  ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
  ...theme.paper.header,
  fontSize: 600,
  padding: ".8rem",
}));
const ContractDetailsFrom = ({
  policyHolderId,
  setFilter,
  filter,
  handleClick,
  showSnakBar,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [insureeNumber, setInsureeNumber] = useState("");
  const [policyHolderData, setPolicyHolderData] = useState();
  const [name, setName] = useState("");

  const contractState = useSelector((state) => state);

  useEffect(() => {
    if (policyHolderId) {
      dispatch(fetchContracts([`id: "${policyHolderId}"`]));
    }
  }, [showSnakBar]);
  useEffect(() => {
    if (contractState?.profileReducer?.contracts) {
      setPolicyHolderData(contractState?.profileReducer?.contracts);
    }
  }, [contractState?.profileReducer?.contracts]);

  const onSubmit = async (values) => {
    console.log("values", values);
  };
  return (
    <Grid container>
      <Grid item xs={12}>
        <StyledPaper>
          <StyledPaperHeader>
            {/* <Grid></Grid> */}
            <Grid item alignItems="center">
              <Typography variant="h6">{t("General Information")}</Typography>
            </Grid>
          </StyledPaperHeader>
          <Grid container>
            <Grid item>
              <Grid container>
                <Form
                  onSubmit={onSubmit}
                  // validate={validate}
                  initialValues={policyHolderData ? policyHolderData?.[0] : {}}
                  render={({
                    handleSubmit,
                    form,
                    submitting,
                    pristine,
                    values,
                    errors,
                  }) => {
                    // setFormValues(values),
                    return (
                      <form onSubmit={handleSubmit}>
                        <Grid style={{ display: "flex" }}>
                          <Grid item xs={12} className="common-input">
                            <Field
                              name="code"
                              component={TextInput}
                              disabled={true}
                              label="Code"
                              required
                              type="text"
                              insureeNo={values}
                            />
                          </Grid>
                          <Grid item xs={12} className="common-input">
                            <Field
                              name="validMonthform"
                              component={CalendarPicker}
                              label={t("Valid Month from")}
                              inputVal={formatDateFromISO(
                                values?.dateValidFrom
                              )}
                              disabled
                              // type="text"
                              monthYear
                              onChange={(value) =>
                                form.change("validMonthform", value)
                              }
                            />
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            className="common-input"
                            style={{ marginTop: "2px" }}
                          >
                            <Field
                              name="validMonthTo"
                              component={CalendarPicker}
                              label={t("Valid Month To")}
                              required
                              inputVal={formatDateFromISO(values?.dateValidTo)}
                              disabled
                              onChange={(value) =>
                                form.change("validMonthTo", value)
                              }
                            />
                          </Grid>
                          <Grid item xs={12} className="common-input">
                            <Field
                              name="amountNotified"
                              component={TextInput}
                              disabled={true}
                              label={t("Amount Notified")}
                              type="text"
                            />
                          </Grid>
                          {/* <Button onClick={handleClose}>Cancel</Button> */}
                          {/* <Grid item xs={12}> */}
                        </Grid>
                        {/* </Grid> */}
                      </form>
                    );
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </StyledPaper>
      </Grid>
    </Grid>
  );
};

export default ContractDetailsFrom;
